export default "__VITE_ASSET__M$cIWJJQ__"